import {BackgroundFileData, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalBackgroundFileData extends BackgroundFileData implements Parameter {
	public name?: string;
	public mimetype?: string;

	constructor(data: any) {
		super(data);

		this.name = FunctionHelper.exists(data?.name) ? data.name : "";
		this.mimetype = FunctionHelper.exists(data?.mimetype) ? data.mimetype : "";
	}

	public static getName(): string {
		return "";
	}

	public static getMimetype(): string {
		return "";
	}

	public static fromJson(data: any): PortalBackgroundFileData {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalBackgroundFileData(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'name': this.name,
			'mimetype': this.mimetype,
		};
	}

	public clone(): PortalBackgroundFileData {
		return PortalBackgroundFileData.fromJson(this.toJson());
	}
}